import { render, staticRenderFns } from "./MenuHeader.vue?vue&type=template&id=6a09b2fe&scoped=true"
import script from "./MenuHeader.vue?vue&type=script&lang=ts"
export * from "./MenuHeader.vue?vue&type=script&lang=ts"
import style0 from "./MenuHeader.vue?vue&type=style&index=0&id=6a09b2fe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a09b2fe",
  null
  
)

export default component.exports